module.exports = __webpack_public_path__ + "static/media/userProfile.f4622e47.svg";